// @ts-nocheck
import { Navigate } from "react-router-dom"
import { AdminDashboardClient } from "@/components/admin/AdminDashboardClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function AdminPage() {
  const { user } = useAuth()
  if (!user || user.role !== "admin") return <Navigate to="/feed" replace />
  return <div className="container-app py-4"><AdminDashboardClient /></div>
}